/**
 * Initialize all component namespaces.
 * */
var femcare = {};
femcare.article = {};
femcare.askExpert = {};
femcare.navigation = {};
femcare.video = { platformVideo: {}, youtubeVideo: {} };
femcare.gallery = {};
femcare.share = {};
femcare.sampleCoupon = {};
femcare.general = {};
femcare.azure = {};
femcare.shared = {};
femcare.search = {};
femcare.product = { panel: { media: {}, info: {} } };
femcare.profile = {};
femcare.image = {};
femcare.footer = {};
femcare.tracking = {};
femcare.globalLanding = {};
femcare.ageVerification = {};
femcare.form = {};
femcare.quiz = {};
femcare.audioPlatform = {};
femcare.callToActionSignpost = {};
femcare.newsletter = {};
femcare.modal = {};